import { render, staticRenderFns } from "./Rubik.vue?vue&type=template&id=0b35e2f2&lang=pug"
import script from "./Rubik.vue?vue&type=script&lang=js"
export * from "./Rubik.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports